//@flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
//types
import { type Match } from 'react-router-dom';
import {
  type Currencies,
  type Currency,
  type TooltipProps
} from '../../../utilities/types';
import CrudTableShow from '../../../modules/CrudTable/CrudTableShow';
import { loadReferredPartnersShow, showTooltip } from './reducer';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableColumn from '../../../modules/CrudTable/components/TableColumn';
import { getPartnerCurrency } from '../../../utilities/selectors';

export type ReferredPartner = {
  currency: string,
  revenue_share: string,
  transaction_amount: string,
  transaction_fee: string,
  id: number
};
type ReferredPartners = Array<ReferredPartner>;

type Props = {
  // // Initialize
  loadReferredPartnersShow: () => void,
  referredPartners: {
    company_name: string,
    email: string,
    id: number,
    processing_sums: ReferredPartners,
    total_merchants: string
  },
  match: Match,
  location: Location,
  loading: boolean,
  failedLoad: boolean,
  currencies: Currencies,
  dashboardShowId?: number,
  dashboardHandleClose?: () => void,
  totalProcessingVolUsd: string,
  totalFeesUsd: string,
  partnerCurrency: Currency,
  ...$Exact<TooltipProps>
};

class ReferredPartnersShow extends Component<Props> {
  render() {
    return (
      <>
        <CrudTableShow
          // Initialize
          loadTableShowData={this.props.loadReferredPartnersShow}
          location={this.props.location}
          match={this.props.match}
          loading={this.props.loading}
          currencies={this.props.currencies}
          failedLoad={this.props.failedLoad}
          // Summary
          TableSummaryColumn={[
            <TableColumn
              key={'SC1'}
              data={[
                ['Contact Name:', this.props.referredPartners.company_name],
                ['Email:', this.props.referredPartners.email],
                [
                  'Total Merchants:',
                  this.props.referredPartners.total_merchants
                ]
              ]}
            />
          ]}
          tableSummaryOptions={{
            title1: this.props.referredPartners.company_name
          }}
          // // Table Body
          tableData={this.props.referredPartners.processing_sums}
          tableBodyOptions={{
            text: 'No Transactions',
            model: 'Partners',
            img: 'receipt',
            showId: this.props.dashboardShowId || NaN,
            handleClose: this.props.dashboardHandleClose || undefined,
            summary: {
              tableTotal: (this.props.referredPartners.processing_sums || [])
                .length,
              totalFeesUsd: this.props.totalFeesUsd,
              totalProcessingVolUsd: this.props.totalProcessingVolUsd,
              partnerCurrency: this.props.partnerCurrency,
              showTooltip: this.props.showTooltip,
              activeTooltip: this.props.activeTooltip
            }
          }}
          // $FlowFixMe
          TableRow={<TableRow />}
          // // Table Header
          TableHeader={<TableHeader />}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  referredPartners: state.partners.referredPartners.show,
  loading: state.partners.referredPartners.show.loading,
  currencies: state.global.currencies,
  failedLoad: state.partners.referredPartners.show.failedLoad,
  totalProcessingVolUsd:
    state.partners.referredPartners.show.total_processing_vol_usd,
  totalFeesUsd: state.partners.referredPartners.show.total_fees_usd,
  partnerCurrency: getPartnerCurrency(state),
  activeTooltip: state.partners.referredPartners.show.activeTooltip
});

const mapDispatchToProps = {
  loadReferredPartnersShow,
  showTooltip
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReferredPartnersShow);
